import React from "react";

const ACCENTS = {
  blue:   { from: "from-blue-500",   to: "to-cyan-400" },
  green:  { from: "from-emerald-500",to: "to-green-400" },
  red:    { from: "from-rose-500",   to: "to-orange-400" },
  yellow: { from: "from-amber-400",  to: "to-yellow-300" },
  purple: { from: "from-violet-500", to: "to-fuchsia-400" },
  black:  { from: "from-slate-700",  to: "to-slate-500" },
};

export default function CardComptaNumber({ title, value, color = "black" }) {
  const accent = ACCENTS[color] || ACCENTS.black;
  const formatted = Math.abs(Math.round(Number(value || 0)));

  return (
    <div
      className="rounded-2xl ring-1 ring-slate-200 dark:ring-slate-700 bg-white/90 dark:bg-slate-900/60 backdrop-blur p-4 shadow-sm flex flex-col"
      aria-label={title}
      title={title}
    >
      {/* Accent */}
      <div className={`h-1.5 w-16 rounded-full bg-gradient-to-r ${accent.from} ${accent.to}`} />

      {/* Titre */}
      <div className="mt-3 text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400">
        {title}
      </div>

      {/* Valeur */}
      <div className="mt-1 text-3xl font-semibold tracking-tight text-slate-900 dark:text-white tabular-nums">
        {formatted}
      </div>
    </div>
  );
}
